import { namespacedService } from '../utils';

export const RedirectServices = {
  AdviceHandlers: namespacedService('adviceRedirectHandlers'),
  FreeHandlers: namespacedService('freeRedirectHandlers'),
  RedirectContext: namespacedService('redirectContext'),
  RedirectService: namespacedService('redirectService'),
};
